import { Injectable } from "@angular/core";
import { PlanTreatmentsService } from "./plan-treatments.service";
import { PlanItem } from "./plan.model";
import { DescriptionService } from "../../description/description.service";
import { Observable } from "rxjs";
import {
  DescriptionFull,
  DescriptionItem,
} from "../../description/description.model";
import { CustomTreatmentService } from "../../custom-treatment/custom-treatment.service";
import { CustomTreatment } from "../../custom-treatment/custom-treatment.model";

@Injectable()
export class PlanDescriptionsService {
  private descriptions$: Observable<DescriptionFull>;
  private customTreatments: CustomTreatment[];

  constructor(
    private descriptionsService: DescriptionService,
    private treatmentsService: PlanTreatmentsService,
    private customTreatmentService: CustomTreatmentService,
  ) {
    this.descriptions$ = descriptionsService.getFullDescriptions("plan");
    this.getCustomTreatments();
  }

  async getCustomTreatments() {
    this.customTreatments = await this.customTreatmentService
      .getCustomTreatments(true)
      .toPromise();
  }

  getDescriptions(items: PlanItem[]): Observable<DescriptionItem[]> {
    return this.descriptions$.switchMap((descriptions) => {
      const addedDescriptions = [];
      const finalDescriptions = [];

      if (items) {
        for (const item of items) {
          if (item.customTreatmentId) {
            // get custom treatment description only if it is
            const customTreatmentDescription = this.customTreatments.filter(
              (customTreatment) =>
                customTreatment.id === item.customTreatmentId &&
                customTreatment.description !== null &&
                customTreatment.description.length > 0,
            );

            const customDescriptionName = item.name;
            const customDescriptionContent =
              customTreatmentDescription.length > 0
                ? customTreatmentDescription[0].description
                : descriptions[item.treatment]
                  ? descriptions[item.treatment].content
                  : "";

            if (!customDescriptionContent) {
              continue;
            }

            const customDescription = {
              name: customDescriptionName,
              content: customDescriptionContent,
            };

            if (addedDescriptions.includes(item.customTreatmentId)) {
              continue;
            }

            addedDescriptions.push(item.customTreatmentId);
            finalDescriptions.push(customDescription);

            continue;
          }

          const conditionClass = this.treatmentsService.getClassForTreatment(
            item.treatment,
          );
          const descriptionsIdentifiers =
            conditionClass.getDescriptionIdentifiers(item);

          for (const identifier of descriptionsIdentifiers) {
            if (!addedDescriptions.includes(identifier)) {
              addedDescriptions.push(identifier);
              if (descriptions[identifier]) {
                finalDescriptions.push(descriptions[identifier]);
              }
            }
          }
        }
      }

      return Observable.of(finalDescriptions);
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/plan-descriptions.service.ts